import React, {useEffect, useState} from 'react';
import {firestore} from '../../Firebase';
import Heading from '../../Heading/JavaScript/Heading';
import MZAS_LOGO from '../Assets/MZAS_LOGO.svg';

function About() {
    const [aboutData, setAboutData] = useState([{text: ""}]);
    
    useEffect(
        () => {
            firestore.collection("About").onSnapshot(
                (snapShot) => {
                    setAboutData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    text: doc.data().text
                                }
                            )
                        )
                    )
                }
            )
        }, []
    )
    
    useEffect(
        () => {
            if (aboutData.length === 0) {
                let aboutSection = document.getElementsByClassName("about")[0];
                
                aboutSection.style.display = "none";
            }
            else {
                let aboutSection = document.getElementsByClassName("about")[0];
                
                aboutSection.style.display = "grid";
            }
        }, [aboutData.length]
    )
    
    return (
        <section className="about">
            <Heading text="About Us" />
            <div className="about__text" data-aos="zoom-out" data-aos-delay="200">
                {aboutData[0].text}
            </div>
            <div className="about__img" data-aos="fade-left" data-aos-delay="300">
                <img src={MZAS_LOGO} alt="MZAS Logo" />
            </div>
        </section>
    )
}

export default About